import { render, staticRenderFns } from "./MisVentas.vue?vue&type=template&id=4cb582af&"
import script from "./MisVentas.vue?vue&type=script&lang=js&"
export * from "./MisVentas.vue?vue&type=script&lang=js&"
import style0 from "./MisVentas.vue?vue&type=style&index=0&id=4cb582af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports